module.exports = __webpack_public_path__ + "img/icon-x-claro.b9f6b3b7.svg";